<div class="wrap">
  <div class="logoWrapper">
    <fa-icon [icon]="faSitemap"></fa-icon>
    <h1>Smart hub</h1>
    <!-- <img src="/assets/icons/cph-logo-b.png" alt="Logo CPH bleu"> -->
  </div>
  <div class="login-card">
    <p>Connect to your account</p>
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="formField">
        <mat-icon color="primary">
          account_box
        </mat-icon>
        <mat-form-field appearance="outline">
          <mat-label>
            Username
          </mat-label>
          <input type="text" matInput formControlName="username">
          <mat-error>Username required.</mat-error>
        </mat-form-field>
      </div>

      <div class="formField">
        <mat-icon color="primary">
          lock
        </mat-icon>
        <mat-form-field appearance="outline">
          <mat-label>
            Password</mat-label>
          <input type="password" matInput formControlName="password">
          <mat-hint align="end"><a routerLink="/login/forgot-password">Forgot password ?</a>
          </mat-hint>
          <mat-error>Password required.</mat-error>
        </mat-form-field>
      </div>


      <button type="submit" mat-raised-button color="primary" *ngIf="!isLoading" [disabled]="loginForm.invalid">Connect</button>
      <mat-spinner *ngIf="isLoading" [diameter]="35" color="primary"></mat-spinner>
    </form>
  </div>
